export class PlayerStat {
    gp: number = 0;
    g: number = 0;
    a: number = 0;
    p: number = 0;
    pim: number = 0;
    plusMinus: number = 0;
    ga: number = 0;
    ta: number = 0;
    sog: number = 0;
    s: number = 0;
    ht: number = 0;
    sb: number = 0;
    fo: number = 0;
    totalToi: number = 0;
    atoi: string = "";
    avr: number = 0;

    add(stat: any) {
        this.gp += stat.GP;
        this.g += stat.G;
        this.a += stat.A;
        this.pim += stat.PIM;
        this.plusMinus += stat.PlusMinus;
        this.ga += stat.GA;
        this.ta += stat.TA;
        this.sog += stat.SOG;
        this.s += stat.S;
        this.ht += stat.HT;
        this.sb += stat.SB;
        this.fo += stat.FO;
        this.totalToi += this.getSecs(stat.ATOI);
        this.avr += stat.AvR;
    }

    getSecs(num: string): number {
        let mins: number = parseInt(num.split(":")[0]);
        let secs: number = parseInt(num.split(":")[1]);
        return mins * 60 + secs;
    }
}

export class GoalieStat {
    gp: number = 0;
    w: number = 0;
    l: number = 0;
    otl: number = 0;
    mins: number = 0;
    ga: number = 0;
    gaa: number = 0;
    sv: number = 0;
    so: number = 0;
    avr: number = 0;

    add(stat: any) {
        this.gp += stat.GP;
        this.w += stat.W;
        this.l += stat.L;
        this.otl += stat.OTL;
        this.mins += stat.Mins;
        this.ga += stat.GA;
        this.gaa += stat.GAA;
        this.sv += stat.Sv;
        this.so += stat.SO;
        this.avr += stat.AvR;
    }
}